import Typewriter from "typewriter-effect";
import resume from "../../Ahmad Subaktagin Jabir.pdf";
import newHero from "../../assets/images/new-hero.png";
import "./Hero.css";

const Hero = () => {
  return (
    <div className="container hero">
      <div className="row d-flex align-items-center">
        <div className="col-lg-6 order-last order-lg-first">
          <h1 className="fw-bold">
            Hi, I'm{" "}
            <span style={{ color: "#5e60ce" }}>
              Ahmad Subaktagin Jabir, a
              <Typewriter
                options={{
                  strings: [
                    "Web Developer",
                    "Software Tester",
                    "Coder",
                    "Student",
                  ],
                  autoStart: true,
                  loop: true,
                }}
              />
            </span>
          </h1>
          <p>
            An enthusiastic and hardworking person who has special passion for
            programming, web development, testing softwares, managing databases
            and designing user interfaces. I like to learn new things around me
            and I am very efficient with teamwork.
          </p>
          <div className="d-grid gap-2 d-md-block">
            <a target="_blank" href={resume} rel="noreferrer">
              <button className="btn_shadow">View My Resume</button>
            </a>
          </div>
        </div>
        <div className="col-lg-6">
          <img src={newHero} className="img-fluid w-100" alt="..." />
        </div>
      </div>
    </div>
  );
};

export default Hero;
